import Vue from 'vue'
let api = 'http://www.ysechina.net';
export default {
    install () {
        Vue.prototype.$api = api;
    }
}